<div class="container-fluid" *ngIf="caseId">
    <div class="row" style="margin-top: 30px; margin-bottom: 30px;">

        <div class="col-sm-12">
            <div class="row">

                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl" *ngFor="let casePage of detailedCasePages">
                    <button id="{{idPrefix}}btn.{{casePage.pageDetail}}"
                            mat-raised-button
                            class="full-width mt-1"
                            [ngClass]="{'mat-accent': casePage.isActive }"
                            (click)="navigateTo(casePage.page)">{{ casePage.title | translate }}
                    </button>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl pt-1" *permissions="[Permission.SMP_CASE_SWITCH_VIEW]">
                    <quick-detailed-switch [idPrefix]="'case.'" [caseId]="caseId"></quick-detailed-switch>
                </div>

            </div>
        </div>

    </div>
</div>

